import type { LicenceResponse } from '@shared/schemas';

import api from '@/shared/api/api-client';

import type { LicenceQueryGateway } from './licence-query';

/**
 * Real HTTP implementation of the shared licence-read layer. The request is kept
 * 1:1 with the original `useApi<LicenceResponse[]>('/licences')` the wizards'
 * dropdowns used, and both feature gateways spread this in.
 */
export const licenceQueryHttp: LicenceQueryGateway = {
  fetchLicences: () => api.get<LicenceResponse[]>('/licences'),
};
